module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_14-3f02bfa2638748ae68a238106ea29733.png";